<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><a id="page-i"></a>“IT’S GETTING HARDER AND HARDER <br/>TO BEHAVE LIKE A GENTLEMAN <br/>AND KEEP MY HANDS OFF YOU.”</h1>
<p class="noindent">Zane’s head lowered just as Riley’s lifted, and his mouth covered hers. He’d intended it to be no more than a simple good-night
         kiss, but the instant their lips met, everything changed.
      </p>
<p>His arms wrapped around her, drawing her close. While his mouth moved over hers, he could feel her in every part of his body.
         The softness of her breasts against his chest. The press of her thighs to his. The tingle of warmth as her arms slowly lifted
         until they closed around his neck. And clung.
      </p>
<p>He heard her little sigh of pleasure as she offered her lips for more.</p>
<p>Somewhere in his mind an alarm bell went off and he realized that he needed to take a step back.</p>
<p>But not just yet. He wanted, needed, one more taste of her. One more kiss before leaving.</p>
<p>Zane took Riley fully into the kiss and could feel himself sinking into her. Into all that sweetness. And losing himself completely…</p>
<blockquote class="blockquote">
<p class="noindent">“A popular writer of heartwarming, emotionally involving romances.”</p>
<p class="attribution">—<em>Library Journal</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?6633b974